export default [
  {
    title: 'Account',
    route: 'account',
    icon: 'UserIcon',
  },
  {
    title: 'Bill',
    route: 'apps-email',
    icon: 'FileTextIcon',
  },
  {
    title: 'Statement',
    route: 'apps-email',
    icon: 'BookOpenIcon',
  },
]
